package io.horion.cv.styles

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import org.jetbrains.compose.web.css.px

val RealisationDescriptionStyle = CssStyle {
    // Mobile (< SM)
    base {
        Modifier.fillMaxWidth()
    }
    // Tablette (>= SM)
    Breakpoint.SM {
        Modifier.width(500.px)
    }
    // Desktop (>= MD)
    Breakpoint.MD {
        Modifier.width(770.px)
    }
}